import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=4d56d48c&scoped=true"
import script from "./Documentos.vue?vue&type=script&lang=js"
export * from "./Documentos.vue?vue&type=script&lang=js"
import style0 from "./Documentos.vue?vue&type=style&index=0&id=4d56d48c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d56d48c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d56d48c')) {
      api.createRecord('4d56d48c', component.options)
    } else {
      api.reload('4d56d48c', component.options)
    }
    module.hot.accept("./Documentos.vue?vue&type=template&id=4d56d48c&scoped=true", function () {
      api.rerender('4d56d48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/infoBase/Documentos.vue"
export default component.exports